// @flow
import icons from '~/core/constants/icons/weather-svg';

/* eslint-disable camelcase */
export default {
    cloudy: icons.WHITE_CLOUD,
    white_cloud: icons.WHITE_CLOUD,
    sunny_intervals: icons.SUNNY_INTERVALS,
    cloudy_with_light_rain: icons.CLOUDY_WITH_LIGHT_RAIN,
    cloudy_with_heavy_rain: icons.CLOUDY_WITH_HEAVY_RAIN,
    heavy_rain_showers: icons.HEAVY_RAIN_SHOWERS,
    light_rain_showers: icons.LIGHT_RAIN_SHOWERS,
    cloudy_with_light_snow: icons.LIGHT_SNOW,
    light_snow: icons.LIGHT_SNOW,
    light_snow_showers: icons.LIGHT_SNOW_SHOWERS,
    cloudy_with_heavy_snow: icons.CLOUDY_WITH_HEAVY_SNOW,
    heavy_snow_showers: icons.HEAVY_SNOW_SHOWERS,
    thunderstorms: icons.THUNDERSTORMS,
    thundery_showers: icons.THUNDER_SHOWERS,
    cloudy_with_sleet: icons.CLOUDY_WITH_SLEET,
    sleet_showers: icons.SLEET_SHOWERS,
    sunny: icons.SUNNY,
    clear_sky: icons.SUNNY,
    black_low_cloud: icons.BLACK_LOW_CLOUD,
    fog: icons.FOG_MIST,
    mist: icons.FOG_MIST
};
/* eslint-enable camelcase */



// WEBPACK FOOTER //
// ./src/components/widgets/info-bar/icons.js